// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CCtW","label":"styles_label__1s2te"};